.closedControlPanel {
  position: absolute;
  bottom: var(--spacing-48);
  left: var(--spacing-16);
  z-index: 5;
  pointer-events: all;
  display: column;
  align-items: center;
  gap: var(--spacing-12);

  .compactSummaryContainer {
    display: flex;
    margin-top: 12px;
    padding: 16px;
    background-color: var(--bg);
    gap: 16px;
    box-shadow: var(--sparky-elevation-3);
    border-radius: 12px;

    .compactSummary {
      display: flex;
      gap: 4px;
      padding: 2px 0;

      span {
        display: flex;
      }
    }
  }
}

.summaryPanel {
  position: absolute;
  bottom: 48px;
  left: 16px;
  z-index: 5;
  pointer-events: all;
  display: flex;
  flex-direction: column;
  box-shadow: var(--sparky-elevation-3);

  .divider {
    border-top: 1px solid var(--sparky-grey-200);
    margin: 0 0 20px 0;
  }

  .topContainer {
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-16);
    position: relative;
    padding: 12px 12px 10px 16px;

    .togglePanelButton {
      position: absolute;
      right: -52px;
      top: var(--spacing-12);

      button {
        background-color: var(--sparky-brand-white);
      }
    }

    .summaryBlock {
      display: flex;
      flex-direction: column;
      row-gap: var(--spacing-04);

      .blockTitle {
        display: flex;
        line-height: var(--spacing-24);
      }

      .blockValue {
        line-height: normal;
      }
    }
  }

  .controlContainer {
    border-top: 1px solid var(--sparky-grey-200);
    border-bottom: 1px solid var(--sparky-grey-200);
    padding: var(--spacing-24) 0;
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-24);
    margin-bottom: var(--spacing-24);
  }

  .legendContainer {
    padding: 0 12px 16px 16px;

    .legendTitle {
      margin-bottom: var(--spacing-12);
    }

    .legendItemRow {
      display: flex;
      column-gap: var(--spacing-08);
      align-items: center;
      padding: 10.5px 8px;

      .legendIcon {
        display: flex;
        column-gap: var(--spacing-04);
      }
    }
  }

  .scaleLegend {
    width: 250px;
    padding: 10px 8px;
    max-width: 100%;

    .gradiantBar {
      width: 100%;
      height: var(--spacing-12);
    }
  }
}

.iconPair {
  display: flex;

  svg {
    &:nth-child(2) {
      margin-left: -4px;
    }
  }
}
